import "./AppLayout.css";
import { Outlet } from "react-router-dom";
import { Header } from "./Header";
import { Sidebar } from "./Sidebar";
import { useNavigate } from "react-router-dom";
import { useGlobal } from "../../context/GlobalContext";

export function AppLayout() {
    const navigate = useNavigate();
    const { setEmail, setUserKey, setUserName, setProjects } = useGlobal();

    const handleLogout = () => {
        localStorage.removeItem('overwatchai_context');
        setEmail('');
        setUserKey('');
        setUserName('');
        setProjects([]);
        navigate('/');
    };

    return (
        <div className="app-layout">
            <Header variant="app" onLogout={handleLogout} />
            <div className="app-content">
                <Sidebar />
                <main className="app-main">
                    <Outlet />
                </main>
            </div>
        </div>
    );
}
